import { FC } from 'react';

import {
  Button,
  FontWeightEnum,
  Heading,
  HeadingEnum,
  Icon,
  Link,
  Message,
  MessageTypes,
} from '@argenta/react-ui';
import { faAward, faCoins, faGift, faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from '@lingui/macro';
import { Trans } from '@lingui/react';

import { useGetJobId } from '../../hooks/navigation/useGetJobId';
import { useI18nNavigate } from '../../hooks/navigation/useI18nNavigate';
import { VacancyApplicationLocationState } from '../../pages/VacancyApplication/VacancyApplication.types';
import { VacanciesRoute } from '../../routers/AppRouter/routes';
import { ServerHtml } from '../ServerHtml';
import { VacancyBadges } from '../VacancyBadges';
import { VacancyDetailsProps } from '../VacancyDetails/VacancyDetails.types';

import './VacancyDetailsOld.styles.scss';

export const VacancyDetailsOld: FC<VacancyDetailsProps> = ({ vacancyDetails }) => {
  const navigate = useI18nNavigate<VacancyApplicationLocationState>();
  const jobId = useGetJobId();

  const handleApplicationClick = (): void => {
    navigate(VacanciesRoute.VACANCY_APPLICATION_FORM, { state: { ...vacancyDetails, jobId } });
  };

  return (
    <main className="argnt-c-vacancy-details-old">
      <div className="argnt-c-vacancy-details__content">
        <VacancyBadges schedule={vacancyDetails.schedule} location={vacancyDetails.location} />
        <address className="argnt-c-vacancy-details__address">
          <div className="argnt-c-vacancy-details__address--city">{vacancyDetails.addressData}</div>
        </address>
        <section className="argnt-c-vacancy-details__intro-text">
          <ServerHtml htmlString={vacancyDetails.description} />
        </section>
      </div>

      <Message type={MessageTypes.Success} hideIcon>
        <section>
          <Heading type={HeadingEnum.H3} fontWeight={FontWeightEnum.REGULAR}>
            <Icon icon="Group" size={48} />

            <Trans id="vacancies.details.team.title" values={{}} components={{}} />
          </Heading>

          <ServerHtml htmlString={vacancyDetails.teamDescription} />
        </section>

        <section>
          <Heading type={HeadingEnum.H3} fontWeight={FontWeightEnum.REGULAR}>
            <Icon icon="RechttoeRechtaan" size={48} />

            <Trans id="vacancies.details.argentaMatch.title" values={{}} components={{}} />
          </Heading>

          <p>
            <Trans id="vacancies.details.argentaMatch.body" values={{}} components={{}} />
          </p>

          <Link
            className="argnt-c-vacancy-details__match-link"
            href={t({ id: 'vacancies.details.argentaMatch.link.href' })}
            target="_blank"
          >
            <Trans id="vacancies.details.argentaMatch.link.text" values={{}} components={{}} />
          </Link>
        </section>
      </Message>

      <div className="argnt-c-vacancy-details__content">
        <section>
          <Heading type={HeadingEnum.H3} fontWeight={FontWeightEnum.REGULAR}>
            <div className="argnt-c-vacancy-details__icon-wrapper">
              <FontAwesomeIcon icon={faCoins} />
            </div>
            <Trans id="vacancies.details.salaryPackage.title" values={{}} components={{}} />
          </Heading>
          <ServerHtml htmlString={vacancyDetails.paycheckDescription} />
        </section>

        <section>
          <Heading type={HeadingEnum.H3} fontWeight={FontWeightEnum.REGULAR}>
            <div className="argnt-c-vacancy-details__icon-wrapper">
              <FontAwesomeIcon icon={faGift} />
            </div>
            <Trans id="vacancies.details.extra.title" values={{}} components={{}} />
          </Heading>
          <p>
            <Trans id="vacancies.details.extra.body" values={{}} components={{}} />
          </p>
        </section>

        <section>
          <Heading type={HeadingEnum.H3} fontWeight={FontWeightEnum.REGULAR}>
            <div className="argnt-c-vacancy-details__icon-wrapper">
              <FontAwesomeIcon icon={faAward} />
            </div>
            <Trans id="vacancies.details.yourAssets.title" values={{}} components={{}} />
          </Heading>
          <ServerHtml htmlString={vacancyDetails.yourAssets} />
        </section>

        <section>
          <Heading type={HeadingEnum.H3} fontWeight={FontWeightEnum.REGULAR}>
            <div className="argnt-c-vacancy-details__icon-wrapper">
              <FontAwesomeIcon icon={faInfoCircle} />
            </div>
            <Trans id="vacancies.details.questions.title" values={{}} components={{}} />
          </Heading>
          <ServerHtml htmlString={vacancyDetails.questions} />
        </section>
      </div>

      <Message type={MessageTypes.Success} hideIcon>
        <section>
          <Heading type={HeadingEnum.H3} fontWeight={FontWeightEnum.REGULAR}>
            <Trans id="vacancies.details.ready.title" values={{}} components={{}} />
          </Heading>
          <ol>
            <li>
              <Trans id="vacancies.details.ready.list1" values={{}} components={{}} />
            </li>
            <li>
              <Trans id="vacancies.details.ready.list2" values={{}} components={{}} />
            </li>
            <li>
              <Trans id="vacancies.details.ready.list3" values={{}} components={{}} />
            </li>
            <li>
              <Trans id="vacancies.details.ready.list4" values={{}} components={{}} />
            </li>
          </ol>
        </section>
      </Message>

      <Button className="argnt-c-vacancy-details__apply-button" onClick={handleApplicationClick}>
        <Trans id="vacancies.details.applyOnline" values={{}} components={{}} />
      </Button>
    </main>
  );
};
